module.exports = __webpack_public_path__ + "static/img/02.bf3ebab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/02.jpg
// module id = gab3
// module chunks = 18